function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var _require = require('./nft-tuples'),
  slipTypeId = _require.slipTypeId,
  slipAmount = _require.slipAmount,
  nftQuantityFromSlips = _require.nftQuantityFromSlips;
var SAITO_SLIP_TYPES = new Set([0, 10]); // Normal, P2SH

function slipPublicKey(slip) {
  return (slip === null || slip === void 0 ? void 0 : slip.publicKey) || (slip === null || slip === void 0 ? void 0 : slip.public_key) || '';
}
function addSaito(totals, slips, sign) {
  for (var i = 0; i < (slips || []).length; i++) {
    var slip = slips[i];
    if (!SAITO_SLIP_TYPES.has(slipTypeId(slip))) {
      continue;
    }
    var key = slipPublicKey(slip);
    var amount = slipAmount(slip);
    if (!key || amount === 0n) {
      continue;
    }
    totals.set(key, (totals.get(key) || 0n) + sign * amount);
  }
}
function movesSaito(tx) {
  var nets = new Map();
  addSaito(nets, tx === null || tx === void 0 ? void 0 : tx.from, -1n);
  addSaito(nets, tx === null || tx === void 0 ? void 0 : tx.to, 1n);
  var _iterator = _createForOfIteratorHelper(nets.values()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var net = _step.value;
      if (net !== 0n) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
}
function movesNft(tx) {
  return nftQuantityFromSlips(tx === null || tx === void 0 ? void 0 : tx.from) > 0n || nftQuantityFromSlips(tx === null || tx === void 0 ? void 0 : tx.to) > 0n;
}
function buildTransactionIndexRows(blk) {
  var transactions = Array.isArray(blk === null || blk === void 0 ? void 0 : blk.transactions) ? blk.transactions : [];
  var blockId = Number(blk === null || blk === void 0 ? void 0 : blk.id);
  var blockHash = String((blk === null || blk === void 0 ? void 0 : blk.hash) || '');
  if (!blockHash || !Number.isFinite(blockId) || blockId <= 0) {
    return [];
  }
  var createdAt = Number((blk === null || blk === void 0 ? void 0 : blk.timestamp) || Date.now());
  var rows = [];
  for (var i = 0; i < transactions.length; i++) {
    var tx = transactions[i];
    var signature = String((tx === null || tx === void 0 ? void 0 : tx.signature) || '');
    if (!signature || !movesSaito(tx) && !movesNft(tx)) {
      continue;
    }
    var txCreatedAt = Number(tx === null || tx === void 0 ? void 0 : tx.timestamp);
    rows.push({
      block_id: blockId,
      block_hash: blockHash,
      lc: 1,
      signature: signature,
      transaction_id: i,
      created_at: Number.isFinite(txCreatedAt) && txCreatedAt > 0 ? txCreatedAt : createdAt
    });
  }
  return rows;
}
var INDEXED_BLOCK_LIMIT = 1024;
function indexConfirmedBlock(_x, _x2) {
  return _indexConfirmedBlock.apply(this, arguments);
}
function _indexConfirmedBlock() {
  _indexConfirmedBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(mod, blk) {
    var blockHash, blockId, oldest, interval, rows, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          blockHash = String((blk === null || blk === void 0 ? void 0 : blk.hash) || '');
          blockId = Number(blk === null || blk === void 0 ? void 0 : blk.id);
          if (!(!blockHash || !Number.isFinite(blockId) || blockId <= 0)) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          if (!mod.indexedTransactionBlocks.has(blockHash)) {
            _context.n = 2;
            break;
          }
          return _context.a(2);
        case 2:
          mod.indexedTransactionBlocks.add(blockHash);
          if (mod.indexedTransactionBlocks.size > INDEXED_BLOCK_LIMIT) {
            oldest = mod.indexedTransactionBlocks.values().next().value;
            mod.indexedTransactionBlocks["delete"](oldest);
          }
          interval = Number(mod.PRUNE_EVERY_N_BLOCKS) || 100;
          if (blockId % interval === 0) {
            setImmediate(function () {
              mod.pruneDatabase(blockId)["catch"](function (err) {
                console.error('Explorer: database prune failed', err);
              });
            });
          }
          _context.p = 3;
          rows = buildTransactionIndexRows(blk);
          _context.n = 4;
          return mod.database.insertTransactionRows(rows);
        case 4:
          _context.n = 6;
          break;
        case 5:
          _context.p = 5;
          _t = _context.v;
          mod.indexedTransactionBlocks["delete"](blockHash);
          console.error('Explorer: failed to index transactions', _t);
        case 6:
          return _context.a(2);
      }
    }, _callee, null, [[3, 5]]);
  }));
  return _indexConfirmedBlock.apply(this, arguments);
}
module.exports = {
  buildTransactionIndexRows: buildTransactionIndexRows,
  indexConfirmedBlock: indexConfirmedBlock,
  movesNft: movesNft,
  movesSaito: movesSaito
};